exports.module = {
  profile: {
    description:
      "Hi, thank you for visiting my blog. I'm a full stack web developer. React/Ruby on Rails/Go",
    author: {
      description:
        "Hi, thank you for visiting my blog. I'm a full stack web developer. React/Ruby on Rails/Go"
    }
  },
  about: {
    profile: 'Profile'
  },
  messages: {
    'search-posts': "Are you lookging for a post? Let's search"
  },
  labels: {
    404: 'Oops, the page is missing.',
    articles: 'Articles',
    'related-posts': 'Related Posts',
    'pop-posts': 'Popular Posts',
    share: 'Share :',
    'latest-posts': 'Latest Posts',
    pickup: 'Pick Up',
    'search-posts': 'Search Posts',
    sidebar: {
      'profile-title': 'Profile',
      promotion: 'Promotion',
      categories: 'Categories',
      tags: 'Tags',
      'profile-description':
        'Frelance Web Developer in Vancouver. Rails/React/React Native. I post articles about programming, travel and freelance.',
      'profile-link': 'About Me',
      'freelance-title': 'Freelance',
      'archive-by-month': 'Archive'
    }
  },
  categories: {
    freelance: 'Freelance',
    engineering: 'Engineering',
    design: 'Design',
    'for-beginner': 'For Beginner',
    rails: 'Ruby On Rails',
    react: 'React',
    travel: 'Travel',
    column: 'Column',
    'cryptocurrency-blockchain': 'Crypto Currency・Blockchain'
  },
  tags: {
    ansible: 'Ansible',
    activerecord: 'ActiveRecord',
    book: 'Book',
    bitcoin: 'Bitcoin',
    blade: 'Blade',
    blockchain: 'Blockchain',
    'build-env': 'Build Environment',
    ci: 'CI',
    circleci: 'CircleCI',
    codesandbox: 'CodeSandbox',
    cakephp: 'CakePHP',
    career: 'Carrier',
    command: 'Command',
    commentary: 'Commentary',
    coolors: 'coolors.co',
    cryptocurrency: 'Crypto Currency',
    css: 'CSS',
    design: 'Design',
    'design-pattern': 'Design Pattern',
    docker: 'Docker',
    english: 'English',
    exposed: 'Exposed',
    'egg-cutter': 'Egg Cutter',
    editor: 'Editor',
    electron: 'Electron',
    ethereum: 'Etherium',
    freelance: 'Freelance',
    frontend: 'Frontend',
    flyway: 'Flyway',
    ga: 'Google Analytics',
    gatsby: 'Gatsby',
    gadget: 'Gadget',
    git: 'Git',
    go: 'GO',
    gin: 'Gin',
    gqlgen: 'gqlgen',
    gorm: 'Gorm',
    'hello-world': 'Hello World',
    inkdrop: 'Inkdrop',
    javascript: 'Javascript',
    jest: 'Jest',
    kotlin: 'Kotlin',
    khttp: 'Khttp',
    laravel: 'Laravel',
    learning: 'Learning',
    lifehack: 'Lifehack',
    lubuntu: 'Lubuntu',
    lodash: 'Lodash',
    mac: 'Mac',
    marketing: 'Marketing',
    migration: 'Migration',
    mysql: 'MySQL',
    native: 'Native',
    netlify: 'Netlify',
    nginx: 'Nginx',
    nodejs: 'Node.js',
    opinion: 'Opinion',
    oop: 'OOP',
    phantomjs: 'PhatomJS',
    php: 'PHP',
    programming: 'Programming',
    phpunit: 'PHPUnit',
    plugin: 'Plugin',
    product: 'Product',
    postgress: 'PostgresSQL',
    pomodoro: 'Pomodoro',
    react: 'React',
    redux: 'Redux',
    'react-native': 'React Native',
    'react-navigetion': 'React Navigation',
    review: 'Review',
    rails: 'Rails',
    ruby: 'Ruby',
    spa: 'SPA',
    springboot: 'Spring Boot',
    slack: 'Slack',
    smaccs: 'SMACCS',
    snakegame: 'Snake Game',
    serverside: 'Server Side',
    test: 'Test',
    tool: 'Tool',
    travel: 'Travel',
    typescript: 'TypeScript',
    vagrant: 'Vagrant',
    vr: 'VR',
    vue: 'Vue',
    vuex: 'Vuex',
    vim: 'Vim',
    'web-structure': 'Web Structure',
    webpack: 'Webpack',
    wordpress: 'Wordpress',
    work: 'Work'
  }
}
